import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    const isRTL = document.documentElement.dir === 'rtl';

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-bg-card text-text p-4 shadow-2xl z-50 border-t border-gold/20">
            <div className={`container mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-4 ${isRTL ? 'md:flex-row-reverse' : ''}`}>
                <div className={`text-sm text-text-muted ${isRTL ? 'text-right' : 'text-left'}`}>
                    <p>
                        {t('cookieConsentText') || "We use cookies and local storage to ensure you get the best experience on our website. This includes storing your login session."}
                        {' '}
                        <a href="/privacy" className="text-info-400 hover:text-info-300 underline">
                            {t('learnMore') || "Learn more"}
                        </a>
                    </p>
                </div>
                <button
                    onClick={handleAccept}
                    className="bg-info-600 hover:bg-info-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap"
                >
                    {t('accept') || "Accept"}
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
